module.exports = __webpack_public_path__ + "media/images/wwk_logo_new-991c282af084bf3fe560f419f03e6c45.jpg";